
export class GetTasksInputDto {
    companyId: string;
}
